import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RythmStatusPicker } from '../../../../components/entity-picker/rythm-picker/RythmStatusPicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: string; name: string }[] | null;
  onChange: (value: { id: string; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const RythmStatusFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value?.length) return null;
    if (value.length === 1)
      return t(`SERVICECONTRACT.RYTHMSTATUSES.${value[0].id}`);
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <RythmStatusPicker multiple={true} value={value} onChange={onChange} />
    </FilterCard>
  );
};
